export function toggleShowMore(link) {
  const list = link.closest("ul");
  const items = list.querySelectorAll(".show-more-item");
  const isExpanded = link.dataset.expanded === "true";

  const showMoreText = link.dataset.showmoretext;
  const showLessText = link.dataset.showlesstext;

  items.forEach((item) => item.classList.toggle("hidden"));
  link.textContent = isExpanded ? showMoreText : showLessText;
  link.dataset.expanded = isExpanded ? "false" : "true";
}

window.toggleShowMore = toggleShowMore;

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    const btn = accordion.querySelector(".accordion-title");
    const content = accordion.querySelector(".accordion-item");
    const chevron = accordion.querySelector(".chevron");

    btn.addEventListener("click", () => {
      const isOpen = !content.classList.contains("hidden");

      // Toggle visibility
      content.classList.toggle("hidden");
      chevron.classList.toggle("rotate-180");
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.js-tab-toggle');
  const contentBlocks = document.querySelectorAll('.js-tab-content');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;

      // Hide all content blocks
      contentBlocks.forEach(block => {
        block.classList.add('hidden');
      });

      // Remove active class from all buttons
      buttons.forEach(btn => btn.classList.remove('active-tab'));

      // Show the target block
      const target = document.getElementById(targetId);
      if (target) {
        target.classList.remove('hidden');
        // Scroll into view on mobile
        if (window.innerWidth < 768) { // Tailwind's `md:` breakpoint
          setTimeout(() => {
            target.scrollIntoView({
              behavior: 'smooth',
            });
          }, 50); // small delay to ensure visibility
        }
      }

      // Optionally mark active tab
      button.classList.add('active-tab');
    });
  });
});
